declare global {
    const __API_URL__: string;
    const __ENV__: string;
    const __FIREBASE_PROJECT_ID__: string;
    const __FIREBASE_API_KEY__: string;
    const __FIREBASE_MESSAGING_SENDER_ID__: string;
    const __FIREBASE_APP_ID__: string;
    const __ENABLE_SOCIAL_LOGIN__: boolean;
}

export const config = {
    apiUrl: __API_URL__,
    environment: __ENV__,
    firebaseProjectId: __FIREBASE_PROJECT_ID__,
    firebaseApiKey: __FIREBASE_API_KEY__,
    firebaseMessagingSenderId: __FIREBASE_MESSAGING_SENDER_ID__,
    firebaseAppId: __FIREBASE_APP_ID__,
    enableSocialLogin: __ENABLE_SOCIAL_LOGIN__,
    
    isDevelopment: __ENV__ === 'development',
    isProduction: __ENV__ === 'production',
} as const;

export type Config = typeof config; 